import './AdResultRow.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import ExpandToggle from '../../../components/ExpandToggle/ExpandToggle';
import type { AdResultRowDisplay } from '../../types';

const [block, element] = bem('ad-result-row');

export type AdResultRowProps = {
  adId: string;
  adResult: AdResultRowDisplay;
  hasCreative: boolean;
  isExpanded: boolean;
  onToggleExpand: () => void;
};

const AdResultRow = ({
  adId,
  adResult,
  hasCreative,
  isExpanded,
  onToggleExpand,
}: AdResultRowProps): React.JSX.Element => (
  <div className={block()} data-testid={`ad-result-row-${adId}`}>
    <span className={element('toggle-cell')}>
      {hasCreative ? (
        <ExpandToggle isExpanded={isExpanded} onToggle={onToggleExpand} />
      ) : (
        <span className={element('toggle-placeholder')} />
      )}
    </span>
    {adResult.isSuccess ? (
      <span className={element('content')}>
        <div>
          <b>Ad ID:</b> {adResult.adId}
        </div>
        <div>
          <b>Ad Name: </b>
          {adResult.adName}
        </div>
        <div>
          <b>Ad Type:</b> {adResult.adType}
        </div>
      </span>
    ) : (
      <span className={element('content', 'error')}>
        <div>
          <b>Ad Creation Error</b>
        </div>
        <div>
          <b>Ad Name: </b> {adResult.adName}
        </div>
        <div>
          <b>Ad Type:</b> {adResult.adType}
        </div>
        {adResult.error && (
          <div>
            <div>
              <b>Code:</b> {adResult.error.code}
            </div>
            <div>
              <b>Message: </b>
              {adResult.error.message}
            </div>
          </div>
        )}
      </span>
    )}
  </div>
);

export default AdResultRow;
